var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"mb-5"},[_c('FooterNav')],1),_c('p',{staticClass:"text-center"},[_c('small',[_vm._v("Copyright © "+_vm._s(_vm.nowYear)+" 文曲星有限公司 All Rights Reserved.")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }